import * as React from 'react';
import { uniqueId } from 'lodash';

import { isSupportedType } from 'lib/AudioSupport';
import File from 'entities/File';
import MediaPlayer from 'components/MediaPlayer';

/**
 * ## [MediaPlayer](/internal/components/MediaPlayer) for audio files.
 *
 *
 * # Implementation
 *
 * Use `Audio.isSupportedType(type)` to check whether the audio file can be played in the user’s
 * browser.
 *
 *
 * ```example
 * <Audio src="https://www.remind.com/assets/audio/pn.mp3" />
 * ```
 */

type Props = {
  src: string;
  file?: File;
};

type State = {
  id: string;
};

class Audio extends React.Component<Props, State> {
  static isSupportedType = isSupportedType;

  state = {
    id: uniqueId(),
  };

  render() {
    const { file, src } = this.props;
    const { id } = this.state;
    return (
      <div className="Audio">
        <audio id={id} src={src} />
        <MediaPlayer file={file} playerId={id} src={src} theme="light" />
      </div>
    );
  }
}
export default Audio;
